import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Lockup, LockupAvatar, LockupContent, LockupTitle, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { ActionTimeline, ActionTimelineError, ActionTimelineSkeleton } from "../../../../../components/ActionTimeline";
import { useActionErrors } from "../../../../hooks/useErrors";
import { useDropPublishQuery } from "../../hooks/useDropPublishQuery";
export const DropPublishTimeline = t0 => {
  const $ = _c(44);
  const {
    collectionSlug,
    collectionName,
    collectionImageUrl
  } = t0;
  let t1;
  if ($[0] !== collectionSlug) {
    t1 = {
      collectionSlug
    };
    $[0] = collectionSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    actions,
    error,
    fetching,
    refetch
  } = useDropPublishQuery(t1);
  const t = useTranslations("wallet.DropPublishTimeline");
  const {
    size
  } = useTable();
  const {
    image
  } = tableRowSizeVariants({
    size
  });
  const actionError = useActionErrors();
  let t2;
  if ($[2] !== t) {
    t2 = t("publishDropSettings");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const T0 = BottomSheetBody;
  const T1 = Lockup;
  const T2 = LockupAvatar;
  const t4 = image();
  let t5;
  if ($[6] !== T2 || $[7] !== collectionImageUrl || $[8] !== collectionName || $[9] !== t4) {
    t5 = <T2 alt={collectionName} className={t4} src={collectionImageUrl} />;
    $[6] = T2;
    $[7] = collectionImageUrl;
    $[8] = collectionName;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== collectionName) {
    t6 = <LockupContent><LockupTitle color="text-secondary" weight="regular">{collectionName}</LockupTitle></LockupContent>;
    $[11] = collectionName;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T1 || $[14] !== size || $[15] !== t5 || $[16] !== t6) {
    t7 = <T1 size={size}>{t5}{t6}</T1>;
    $[13] = T1;
    $[14] = size;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== T0 || $[19] !== t7) {
    t8 = <T0>{t7}</T0>;
    $[18] = T0;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== fetching) {
    t9 = fetching && <ActionTimelineSkeleton count={1} />;
    $[21] = fetching;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== error || $[24] !== refetch) {
    t10 = error && <ActionTimelineError message="Failed to load drop publishing actions" onRetry={refetch} />;
    $[23] = error;
    $[24] = refetch;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== actionError || $[27] !== refetch) {
    t11 = actionError && <ActionTimelineError message={actionError} onRetry={refetch} />;
    $[26] = actionError;
    $[27] = refetch;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== actionError || $[30] !== actions || $[31] !== error || $[32] !== fetching || $[33] !== refetch) {
    t12 = !(fetching || error || actionError) && <ActionTimeline actions={actions} onReload={refetch} />;
    $[29] = actionError;
    $[30] = actions;
    $[31] = error;
    $[32] = fetching;
    $[33] = refetch;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t9) {
    t13 = <BottomSheetFooter>{t9}{t10}{t11}{t12}</BottomSheetFooter>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t9;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t13 || $[41] !== t3 || $[42] !== t8) {
    t14 = <>{t3}{t8}{t13}</>;
    $[40] = t13;
    $[41] = t3;
    $[42] = t8;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
};